/* eslint no-undef: 0 */
import { ENGLISH_LANG } from 'configs/constants';
import i18n from '../../i18n';

export const getText = (label) => {
    if (!i18n.t(label) || (i18n.t(label) && i18n.t(label).length === 0)) {
        return i18n.t(label, { lng: ENGLISH_LANG });
    } else {
        return i18n.t(label);
    }
};
